<template>
    <div class="applyTeacherWrap">
        <div class="applyTeacherBox">

            <div class="applyTips1" v-if="teacher_status==2">
                <template>
                    <el-alert
                    :title="teacher_status_desc ? teacher_status_desc : '审核未通过，可重新提交申请！'"
                    type="error"
                    center
                    :closable="false"
                    show-icon>
                  </el-alert>

                </template>
            </div>

            <!-- <div class="applyTips1" v-if="teacher_status==1">
                <template>
                      <el-alert
                        :title="teacher_status_desc ? teacher_status_desc : '审核通过'"
                        type="success"
                        center
                        :closable="false"
                        show-icon>
                      </el-alert>
                </template>
            </div> -->



            <div class="applyTips1" v-if="teacher_status==3">
                <template>
                      <el-alert
                        :title="'审核中，请耐心等待'"
                        type="warning"
                        center
                        :closable="false"
                        show-icon>
                      </el-alert>
                </template>
            </div>

            <div class="infoBox" v-if="teacher_status==1">
                <div class="teacher-info">
                    <div class="info-title">
                        <div class="title-decoration"></div>
                        <p class="title-text">老师个人信息</p>
                    </div>
                    <div class="avatar-name">
                        <el-avatar :src="formObj.slogo" :size="36"></el-avatar>
                        <p class="teacher-name">{{ formObj.real_name }}</p>
                    </div>
                </div>
                <div class="info-school">学校：{{ formObj.school_name }}</div>
                <div class="info-status">审核状态：
                    <el-tag
                        type="warning"
                        size="small"
                        effect="plain"
                        >
                        审核成功
                    </el-tag>
                </div>
            </div>

            <div class="formBox" v-else-if="teacher_status>-1">
                <el-form size="medium" :disabled="(teacher_status == 3) || teacher_status == 1" :model="formObj" ref="formObj" :rules="rules" class="formUiClass" label-width="100px" label-position="right">
                    <el-form-item :label="'学校'"  prop="schoolid">
                        <el-select v-model="formObj.schoolid" filterable  disabled  :placeholder="'请选择证件学校'">
                            <el-option v-for="(item,index) in schoolList" :key="index" :label="item.school_name" :value="item.schoolid"> </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item :label="'姓名'" prop="real_name">
                        <el-input v-model="formObj.real_name" :placeholder="'请填写姓名'" v-focus></el-input>
                    </el-form-item>


                    <el-form-item :label="'备注'"  prop="apply_remark">
                        <el-input type="textarea" v-model="formObj.apply_remark" :placeholder="'请填写申请备注'"
                        :rows="4"  maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
            </div>

        </div>
    </div>
</template>
<script>
import {getAjax,postAjax} from '@/api/index.js';
export default{
    props:{
        schoolInfo:{}
    },
    data(){
        return{
            formObj:{
                real_name:'',
                apply_remark:'',
                schoolid:'',
                school_name:'',
                headimgurl:'',
                slogo:''
            },
            schoolList: [],
            rules: {
                real_name: [
                    { required: true, message: '请填写姓名', trigger: 'submit' }
                ],
           /*     certificate_number:  [{ required: true, message:'请填写证件号码', trigger: 'submit'},
                {pattern:/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message:'身份证格式有误请重填',trigger:'blur'}
                ],*/
                schoolid: [
                    { required: true, message: '请选择证件学校', trigger: 'submit' }
                ],
            },
            teacher_status_desc:'',
            teacher_status:-1,
        }
    },
    created(){
        this.getSchools();
        this.getUserInfo();
    },
    methods:{
        getSchools(){
            postAjax('/school/schoolList',{isall:1}).then(res=>{
                if(res.code == 1){
                    this.schoolList = res.data.items;
                    this.$set( this.formObj,'schoolid',this.schoolInfo.schoolid)
                }
            });
        },
        getUserInfo(){
            postAjax('/member/getUserInfo').then(res=>{
                if(res.code == 1){
                    this.formObj.real_name = res.data.real_name?res.data.real_name:'';
                    this.formObj.apply_remark = res.data.apply_remark? res.data.apply_remark:'';
                    this.formObj.schoolid = res.data.teacher_status == 1?(res.data.schoolid?res.data.schoolid:''):this.formObj.schoolid;
                    this.formObj.school_name = res.data.school_name?res.data.school_name:'';
                    this.formObj.headimgurl = res.data.headimgurl;
                    this.formObj.slogo = res.data.slogo;
                    this.teacher_status = res.data.teacher_status == 3?this.formObj.real_name?0:3:res.data.teacher_status;
                    this.teacher_status_desc = res.data.teacher_status_desc;
                    this.teacher_status = res.data.teacher_status;
                    this.$emit('statusEmit',this.teacher_status);
                }
            });
        },
        submitHandle(){
            if((this.teacher_status == 3) || this.teacher_status == 1) return;
            this.$refs['formObj'].validate((valid) => {
                if (valid) {
                    postAjax("/member/saveUserInfo",this.formObj).then(res=>{
                        if(res.code == 1){
                            this.$message({
                                message:'提交成功',
                                type: 'success'
                            });
                            this.getUserInfo();
                        }else{
                            this.$message({
                                message:res.msg,
                                type: 'warning'
                            });
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/homepage/classManagement/dialogScss1.scss';
</style>



// WEBPACK FOOTER //
// src/page/Public/ClassManagement/Students/dialog/applyTeacher.vue